// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shop{
    padding:20px 0px;
    padding-top: 130px;
    
}

.shop-page-container{
    display: grid;
    grid-template-columns: 1fr 5fr;
}
.shop-page-sidebar{
    

    max-width:300px;
    margin:20px;
    margin-top: 50px;  
}
.search-container input{
    max-width:250px;
    height:30px;
  

}
.trending-products-cards {
    position: relative;
    overflow: hidden;
    width: 100%;
    display: flex;
   
    justify-content: center;
    align-items: center;

}


.trending-products-cards ul {
    /* list-style-type: none;
    display: flex;
    margin: 0;
    padding: 0;
    flex-direction: row;

    align-items: center;
    transition: transform 0.2s ease;

    width: max-content; */
    list-style-type: none;
        margin: 0;
        padding: 0;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        /* 4 cards per row, equally spaced */
        gap: 16px;
        /* Adjust gap between cards as needed */
        transition: transform 0.2s ease;
        width: 100%;



}





.product-card li {
    background-color: #fff;
    width: 250px;
    height: 450px;
    margin: 40px 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    flex-shrink: 0;
    border-width: 2px;
    border-color: rgba(0, 0, 0, 0.2);
    border-style: solid;
    

}

.product-card li img {
    margin-top: 10px;
    width: 80%;
    height: 60%;
   
}

/* .product-card p {
    font-family: 'Poppins', sans-serif;
    width: 70%;
    font-weight: 500;

} */

/* .price-details {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

} */

/* .price-details p {
    margin: 0px;
} */

.add-cart {
    display: flex;
    flex-direction: row;


}

.add-cart p {
    font-size: small;
    width: 100%;
}

.scroll-cards {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 0px;
}

.right-scroll,
.left-scroll {
    width: 40px;
    height: 30px;
    background-color: #FFF;
    margin: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border: rgba(0, 0, 0, 0.3);
        border-style: solid;
        border-width: 1px;

}

.right-scroll {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
}

.left-scroll {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}



.shop-carousel-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 50px;
    justify-items: center;
}

.shop-carousel-container h1 {
    font-family: 'Philosopher', serif;
    font-style: italic;
}

.cards-container {
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    justify-content: center;
    /* width: 80%; */
    /* Adjust based on button width */
    margin: 20px 20px;
    /* Space around the cards */
}

.carousel-card {
    background: #fff;
    /* padding: 10px; */
    border-radius: 8px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
    margin:10px 10px;

    width:280px;
    height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

}


.discount-badge {
    position: absolute;
    top: 0px;
    left: 0px;
    background-color: #ed2727;
    /* Optional: background color */
    padding: 5px;
    border-radius: 3px;
    font-weight: bold;
    color: #fff;
    font-family: 'Poppins',sans-serif;
    font-size: 14px;
    letter-spacing: 1px;
    font-weight: 400;
    /* Optional: text color */
}

.sale-information{
    position:absolute;
    top:-20px;
    right:0;
    background-color: #1D742B;
    padding: 5px;
    z-index: 1;
    
    animation: glow 0.8s infinite alternate;
    background: linear-gradient(45deg, #20B839, #1D742B);
}

.sale-information:before{
  
}


/* @keyframes glitter {
    0% {
        transform: translateX(-100%) rotate(45deg);
    }

    100% {
        transform: translateX(100%) rotate(45deg);
    }
} */

@keyframes glow {
    0% {
        box-shadow: 0 0 2px #06FF2E, 0 0 5px ;
    }

    100% {
        box-shadow: 0 0 4px #1D742B, 0 0 20px ;
    }
}
.sale-information p{
    font-size: 12px;
    margin:2px;
    color:#fff;

}




.carousel-card img {
    width: 230px;

    margin-top: 50px;
}

.carousel-card img:hover {
    /* opacity: 0.5 */
}

.carousel-card h5 {
    text-align: center;
    font-family: 'Philosopher', serif;

}

.cart-class {
    width: 40px;
    height: 40px;
    border: rgba(0, 0, 0, 0.3);
    border-style: solid;
    border-radius: 20px;
    border-width: 1px;
    margin-bottom: 20px;
    margin-top: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    justify-items: center;
    align-content: center;
    padding: 0px;
}

.cart-class button {
    width: 15px;
    height: 15px;
    padding: 0px;
    margin-left: 0px;
    border: none;
}

.Scroll-cards {
    margin-top: 50px;
    display: flex;
    flex-direction: row;
}

.Scroll-cards button {
    border: rgba(0, 0, 0, 0.3);
    border-style: solid;
    border-width: 1px;
}

.left-scroll {
    border-bottom-left-radius: 15px;
    border-top-left-radius: 15px;
}

.right-scroll {
    border-bottom-right-radius: 15px;
    border-top-right-radius: 15px;
}

.shop-page-filters{
    width:80%;
    text-align: left;
    margin:20px;
}
.shop-page-filters label{
    margin:5px;
    font-family: 'Poppins',sans-serif;
    font-size: 16px;

}

.shop-page-filters h3{
  font-family: 'Poppins',sans-serif;
  font-size: 20px;
}

.shop-page-filters h4{
    font-family: 'Poppins',sans-serif;
    font-size: 16px;
}

.discount-btn,
.rating-btn{
    font-family: 'Poppins',sans-serif;
    font-size: 14px;
    background-color: #fff;
    font-weight: 500;
}

.discount-btn:hover,
.rating-btn:hover{
    color:#ed2727;
}

.discount-btn.active,
.rating-btn.active {
    color:#ed2727; 
}

.reset-filters-btn{
    margin:20px 0px;
    width:100%;
    height:40px;
    color:#fff;
    background-color: #ed2727;
    font-family: 'Poppins',sans-serif;
}

.reset-filters-btn:hover{
    background-color:#ffa406 ;
}

.sort-filter{
    display: flex;
    height:30px;
    align-items: center;
    margin-right:10%;
    margin-left:auto;
}

.sort-filter h4{
    margin-right:10px;
    font-family: 'Poppins',sans-serif;
    font-weight: 500;
}
.slider {
    width: 100%;
    /* Adjust width as needed */
    margin: 10px auto;
    /* Center the slider horizontally */
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 40px;
}

/* Track styling */
.track {
    background: #ccc;
    /* Track color */
    height: 8px;
    /* Track thickness */
    border-radius: 4px;
    position: relative;
}

/* Thumb styling */
.thumb {
    height: 20px;
    width: 20px;
    background-color: #007aff;
    /* Thumb color */
    border-radius: 50%;
    /* Makes the thumb circular */
    cursor: pointer;
    position: relative;
    top: -8px;
    /* Adjusts vertical alignment of the thumb */
}


.price-label {
    position: absolute;
    top: -30px;
    /* Adjust based on the space above the slider */
    left: 50%;
    transform: translateX(-50%);
    background: #333;
    color: #fff;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
}

@media screen and (max-width:768px){
    .shop{
        padding-top:180px;
    }
    .shop-page-container {
            display: flex;
            flex-direction: column;
            justify-content: center;
            
        }
    .shop-page-sidebar{
        max-width: 80%;
        margin:5% 10%;
    }
    .search-container{
        width:100%;
        display: flex;
        justify-content: center;
    }
.search-container input {
    max-width:90%;
    width:70%;
    margin: 0px 0;
    height: 30px;


}

.sort-filter {
    display: flex;
    height: 30px;
    align-items: center;
    margin-right: auto;
    margin-left:auto;
}
}`, "",{"version":3,"sources":["webpack://./src/Styles/Shop.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;;;IAGI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,WAAW;;;AAGf;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,aAAa;;IAEb,uBAAuB;IACvB,mBAAmB;;AAEvB;;;AAGA;IACI;;;;;;;;;yBASqB;IACrB,qBAAqB;QACjB,SAAS;QACT,UAAU;QACV,aAAa;QACb,qCAAqC;QACrC,oCAAoC;QACpC,SAAS;QACT,uCAAuC;QACvC,+BAA+B;QAC/B,WAAW;;;;AAInB;;;;;;AAMA;IACI,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;;;AAGvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,WAAW;;AAEf;;AAEA;;;;;GAKG;;AAEH;;;;;;GAMG;;AAEH;;GAEG;;AAEH;IACI,aAAa;IACb,mBAAmB;;;AAGvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,0BAA0B;QACtB,mBAAmB;QACnB,iBAAiB;;AAEzB;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;;;AAIA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,2CAA2C;IAC3C,gBAAgB;;IAEhB,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;;AAEtB;;;AAGA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,+BAA+B;IAC/B,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,iCAAiC;IACjC,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,OAAO;IACP,yBAAyB;IACzB,YAAY;IACZ,UAAU;;IAEV,uCAAuC;IACvC,oDAAoD;AACxD;;AAEA;;AAEA;;;AAGA;;;;;;;;GAQG;;AAEH;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,sCAAsC;IAC1C;AACJ;AACA;IACI,eAAe;IACf,UAAU;IACV,UAAU;;AAEd;;;;;AAKA;IACI,YAAY;;IAEZ,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;;AAErC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,UAAU;IACV,iCAAiC;IACjC,eAAe;;AAEnB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;IACI,iCAAiC;IACjC,eAAe;AACnB;;AAEA;;IAEI,iCAAiC;IACjC,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iCAAiC;IACjC,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,2BAA2B;IAC3B,iBAAiB;IACjB,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,4CAA4C;AAChD;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,+CAA+C;IAC/C,SAAS;IACT,2BAA2B;IAC3B,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI;QACI,iBAAiB;IACrB;IACA;YACQ,aAAa;YACb,sBAAsB;YACtB,uBAAuB;;QAE3B;IACJ;QACI,cAAc;QACd,aAAa;IACjB;IACA;QACI,UAAU;QACV,aAAa;QACb,uBAAuB;IAC3B;AACJ;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,YAAY;;;AAGhB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;AACA","sourcesContent":[".shop{\n    padding:20px 0px;\n    padding-top: 130px;\n    \n}\n\n.shop-page-container{\n    display: grid;\n    grid-template-columns: 1fr 5fr;\n}\n.shop-page-sidebar{\n    \n\n    max-width:300px;\n    margin:20px;\n    margin-top: 50px;  \n}\n.search-container input{\n    max-width:250px;\n    height:30px;\n  \n\n}\n.trending-products-cards {\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n    display: flex;\n   \n    justify-content: center;\n    align-items: center;\n\n}\n\n\n.trending-products-cards ul {\n    /* list-style-type: none;\n    display: flex;\n    margin: 0;\n    padding: 0;\n    flex-direction: row;\n\n    align-items: center;\n    transition: transform 0.2s ease;\n\n    width: max-content; */\n    list-style-type: none;\n        margin: 0;\n        padding: 0;\n        display: grid;\n        grid-template-columns: repeat(4, 1fr);\n        /* 4 cards per row, equally spaced */\n        gap: 16px;\n        /* Adjust gap between cards as needed */\n        transition: transform 0.2s ease;\n        width: 100%;\n\n\n\n}\n\n\n\n\n\n.product-card li {\n    background-color: #fff;\n    width: 250px;\n    height: 450px;\n    margin: 40px 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-radius: 10px;\n    flex-shrink: 0;\n    border-width: 2px;\n    border-color: rgba(0, 0, 0, 0.2);\n    border-style: solid;\n    \n\n}\n\n.product-card li img {\n    margin-top: 10px;\n    width: 80%;\n    height: 60%;\n   \n}\n\n/* .product-card p {\n    font-family: 'Poppins', sans-serif;\n    width: 70%;\n    font-weight: 500;\n\n} */\n\n/* .price-details {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n\n} */\n\n/* .price-details p {\n    margin: 0px;\n} */\n\n.add-cart {\n    display: flex;\n    flex-direction: row;\n\n\n}\n\n.add-cart p {\n    font-size: small;\n    width: 100%;\n}\n\n.scroll-cards {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    margin-top: 0px;\n}\n\n.right-scroll,\n.left-scroll {\n    width: 40px;\n    height: 30px;\n    background-color: #FFF;\n    margin: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    border: rgba(0, 0, 0, 0.3);\n        border-style: solid;\n        border-width: 1px;\n\n}\n\n.right-scroll {\n    border-top-right-radius: 5px;\n    border-bottom-right-radius: 5px;\n}\n\n.left-scroll {\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px;\n}\n\n\n\n.shop-carousel-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 50px;\n    justify-items: center;\n}\n\n.shop-carousel-container h1 {\n    font-family: 'Philosopher', serif;\n    font-style: italic;\n}\n\n.cards-container {\n    display: flex;\n    flex-wrap: wrap;\n    overflow: hidden;\n    justify-content: center;\n    /* width: 80%; */\n    /* Adjust based on button width */\n    margin: 20px 20px;\n    /* Space around the cards */\n}\n\n.carousel-card {\n    background: #fff;\n    /* padding: 10px; */\n    border-radius: 8px;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);\n    margin:10px 10px;\n\n    width:280px;\n    height: 500px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n\n}\n\n\n.discount-badge {\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    background-color: #ed2727;\n    /* Optional: background color */\n    padding: 5px;\n    border-radius: 3px;\n    font-weight: bold;\n    color: #fff;\n    font-family: 'Poppins',sans-serif;\n    font-size: 14px;\n    letter-spacing: 1px;\n    font-weight: 400;\n    /* Optional: text color */\n}\n\n.sale-information{\n    position:absolute;\n    top:-20px;\n    right:0;\n    background-color: #1D742B;\n    padding: 5px;\n    z-index: 1;\n    \n    animation: glow 0.8s infinite alternate;\n    background: linear-gradient(45deg, #20B839, #1D742B);\n}\n\n.sale-information:before{\n  \n}\n\n\n/* @keyframes glitter {\n    0% {\n        transform: translateX(-100%) rotate(45deg);\n    }\n\n    100% {\n        transform: translateX(100%) rotate(45deg);\n    }\n} */\n\n@keyframes glow {\n    0% {\n        box-shadow: 0 0 2px #06FF2E, 0 0 5px ;\n    }\n\n    100% {\n        box-shadow: 0 0 4px #1D742B, 0 0 20px ;\n    }\n}\n.sale-information p{\n    font-size: 12px;\n    margin:2px;\n    color:#fff;\n\n}\n\n\n\n\n.carousel-card img {\n    width: 230px;\n\n    margin-top: 50px;\n}\n\n.carousel-card img:hover {\n    /* opacity: 0.5 */\n}\n\n.carousel-card h5 {\n    text-align: center;\n    font-family: 'Philosopher', serif;\n\n}\n\n.cart-class {\n    width: 40px;\n    height: 40px;\n    border: rgba(0, 0, 0, 0.3);\n    border-style: solid;\n    border-radius: 20px;\n    border-width: 1px;\n    margin-bottom: 20px;\n    margin-top: 0px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    justify-items: center;\n    align-content: center;\n    padding: 0px;\n}\n\n.cart-class button {\n    width: 15px;\n    height: 15px;\n    padding: 0px;\n    margin-left: 0px;\n    border: none;\n}\n\n.Scroll-cards {\n    margin-top: 50px;\n    display: flex;\n    flex-direction: row;\n}\n\n.Scroll-cards button {\n    border: rgba(0, 0, 0, 0.3);\n    border-style: solid;\n    border-width: 1px;\n}\n\n.left-scroll {\n    border-bottom-left-radius: 15px;\n    border-top-left-radius: 15px;\n}\n\n.right-scroll {\n    border-bottom-right-radius: 15px;\n    border-top-right-radius: 15px;\n}\n\n.shop-page-filters{\n    width:80%;\n    text-align: left;\n    margin:20px;\n}\n.shop-page-filters label{\n    margin:5px;\n    font-family: 'Poppins',sans-serif;\n    font-size: 16px;\n\n}\n\n.shop-page-filters h3{\n  font-family: 'Poppins',sans-serif;\n  font-size: 20px;\n}\n\n.shop-page-filters h4{\n    font-family: 'Poppins',sans-serif;\n    font-size: 16px;\n}\n\n.discount-btn,\n.rating-btn{\n    font-family: 'Poppins',sans-serif;\n    font-size: 14px;\n    background-color: #fff;\n    font-weight: 500;\n}\n\n.discount-btn:hover,\n.rating-btn:hover{\n    color:#ed2727;\n}\n\n.discount-btn.active,\n.rating-btn.active {\n    color:#ed2727; \n}\n\n.reset-filters-btn{\n    margin:20px 0px;\n    width:100%;\n    height:40px;\n    color:#fff;\n    background-color: #ed2727;\n    font-family: 'Poppins',sans-serif;\n}\n\n.reset-filters-btn:hover{\n    background-color:#ffa406 ;\n}\n\n.sort-filter{\n    display: flex;\n    height:30px;\n    align-items: center;\n    margin-right:10%;\n    margin-left:auto;\n}\n\n.sort-filter h4{\n    margin-right:10px;\n    font-family: 'Poppins',sans-serif;\n    font-weight: 500;\n}\n.slider {\n    width: 100%;\n    /* Adjust width as needed */\n    margin: 10px auto;\n    /* Center the slider horizontally */\n    position: relative;\n    display: flex;\n    align-items: center;\n    margin-top: 40px;\n}\n\n/* Track styling */\n.track {\n    background: #ccc;\n    /* Track color */\n    height: 8px;\n    /* Track thickness */\n    border-radius: 4px;\n    position: relative;\n}\n\n/* Thumb styling */\n.thumb {\n    height: 20px;\n    width: 20px;\n    background-color: #007aff;\n    /* Thumb color */\n    border-radius: 50%;\n    /* Makes the thumb circular */\n    cursor: pointer;\n    position: relative;\n    top: -8px;\n    /* Adjusts vertical alignment of the thumb */\n}\n\n\n.price-label {\n    position: absolute;\n    top: -30px;\n    /* Adjust based on the space above the slider */\n    left: 50%;\n    transform: translateX(-50%);\n    background: #333;\n    color: #fff;\n    padding: 2px 8px;\n    border-radius: 4px;\n    font-size: 12px;\n    white-space: nowrap;\n}\n\n@media screen and (max-width:768px){\n    .shop{\n        padding-top:180px;\n    }\n    .shop-page-container {\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            \n        }\n    .shop-page-sidebar{\n        max-width: 80%;\n        margin:5% 10%;\n    }\n    .search-container{\n        width:100%;\n        display: flex;\n        justify-content: center;\n    }\n.search-container input {\n    max-width:90%;\n    width:70%;\n    margin: 0px 0;\n    height: 30px;\n\n\n}\n\n.sort-filter {\n    display: flex;\n    height: 30px;\n    align-items: center;\n    margin-right: auto;\n    margin-left:auto;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
